import { ImageKeyUploadField } from "@/shared/ui/ImageKeyUploadField";

export const REWARD_IMAGE_KEY_PREFIX = "uploads/rewards";

export type RewardImageUploadFieldProps = {
  value: string;
  onChange: (key: string) => void;
  pendingFile: File | null;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
  label?: string;
};

export function RewardImageUploadField({
  value,
  onChange,
  pendingFile,
  onFileSelect,
  disabled,
  label = "ຮູບລາງວັນ",
}: RewardImageUploadFieldProps) {
  return (
    <ImageKeyUploadField
      value={value}
      onChange={onChange}
      keyPrefix={REWARD_IMAGE_KEY_PREFIX}
      label={label}
      deferUpload
      pendingFile={pendingFile}
      onFileSelect={(file) => onFileSelect(file ?? null)}
      onClear={() => {
        onFileSelect(null);
        onChange("");
      }}
      disabled={disabled}
      aspectRatio="aspect-square"
      aspectHint="1:1"
      widthPx={512}
      heightPx={512}
      className="w-full max-w-xs"
    />
  );
}
